<div class="auth-flow-logo-container">
  <img src="assets/logo/dark/css-logo.svg" alt="CSS Logo" i18n-alt />
</div>

<div class="auth-flow-title">
  {{ authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  {{ authFlowSubtext$ | async }}
</div>

<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'birthdate'" i18n>Date of Birth</label>
      <app-date-input
        #dateInput
        formControlName="birthdate"
        controlId="birthdate"
        placeholder="dd / mm / yyyy"
        i18n-placeholder
        [error]="(formSubmitted && formGroup.controls.birthdate.invalid) || ((verifyMemberFailed$ | async) ?? false)" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.birthdate.invalid"
        [errors]="formGroup.controls.birthdate.errors"
        [customErrorMessages]="customErrorMessages.birthdate" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'sin'" i18n>Last 3 Digits of Your SIN</label>
      <app-masked-text-input
        formControlName="sin"
        controlId="sin"
        placeholder="--- --- 000"
        i18n-placeholder
        [maskOptions]="sinMaskOptions"
        [error]="(formSubmitted && formGroup.controls.sin.invalid) || ((verifyMemberFailed$ | async) ?? false)"
        (keydown.enter)="verifyMember()" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.sin.invalid"
        [errors]="formGroup.controls.sin.errors"
        [customErrorMessages]="customErrorMessages.sin" />
    </div>
  </div>

  <div class="sign-in-button-container">
    <app-button class="w-100" [type]="ButtonTypeEnum.primary" (buttonClick)="verifyMember()" i18n>Continue</app-button>
  </div>
</div>

<div class="support-button-container">
  <span class="support-button" i18n>Having trouble?</span>
  <button class="paddingless-text-button mt-2" (click)="openContactPage()" i18n>Click here for support</button>
</div>
